/* All standard storefront templates share the homepage search drawer. */
(() => {
 const config=JSON.parse(document.querySelector('#dh-config').textContent);
 const searchPath=(config.root.endsWith('/')?config.root:config.root+'/')+'search';
 document.querySelectorAll('.dc-header a').forEach(link=>{
  if(new URL(link.href,location.href).pathname!==searchPath)return;
  link.setAttribute('data-open-search','');link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','dh-search');
 });
 document.addEventListener('click',event=>{
  if(!event.target.closest('[data-open-search],[data-open-bag]'))return;
  document.querySelectorAll('.dc-nav').forEach(nav=>nav.classList.remove('is-open'));
  document.querySelectorAll('[data-dc-menu]').forEach(button=>button.setAttribute('aria-expanded','false'));
 },true);
})();
